export default "__VITE_ASSET__Dzdt7$3V__"